/* eslint-disable react/prop-types */
import { forwardRef } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide } from "@mui/material";

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const EnrollmentDependencyDialog = ({ dialogProps }) => {
	const { content, openDialog, actions } = dialogProps;

	return (
		<div>
			<Dialog
				style={{ zIndex: 5000 }}
				open={openDialog}
				TransitionComponent={Transition}
				keepMounted
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogContent>
					<DialogContentText id="alert-dialog-slide-description">
						<div className="custom-dialog-content">{content}</div>
					</DialogContentText>
				</DialogContent>
				<DialogActions className="custom-dialog-action-button-container">
					{actions.map((action, index) => {
						const { name, label, callback } = action;
						return (
							<Button
								variant="contained"
								key={index}
								onClick={callback}
								style={{
									backgroundColor: "#3a4652", //"#44b700" --> Green Color
									letterSpacing: "1px",
									fontSize: "0.7rem",
									fontWeight: "bold",
									color: "#ffff",
									marginRight: 10,
									marginLeft: 5
								}}
							>
								{label}
							</Button>
						);
					})}
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default EnrollmentDependencyDialog;
